export function getFirstPartner(partners: Partner[]): Partner {
  const legalPartner = partners[0];

  return legalPartner;
}
